export enum RetoolPage {
  LANDING_PAGE = 'LANDING_PAGE',
  STUDENT_SEARCH = 'STUDENT_SEARCH',
  STUDENT_DETAILS = 'STUDENT_DETAILS',
  STUDENT_LC_REPORT = 'STUDENT_LC_REPORT',
  STUDENT_BULK_UPDATE_ROLL_NO = 'STUDENT_BULK_UPDATE_ROLL_NO',
  SCHOOL_STAFF_DETAILS = 'SCHOOL_STAFF_DETAILS',
  PAYMENT_STUDENT_SEARCH = 'PAYMENT_STUDENT_SEARCH',
  PAYMENT_STUDENT_DETAILS = 'PAYMENT_STUDENT_DETAILS',
  FULL_PAYMENT_CONCESSIONS_MASTER = 'FULL_PAYMENT_CONCESSIONS_MASTER',
  ASSESSMENTS_STATUS = 'ASSESSMENTS_STATUS',
  DECLARATIONS = 'DECLARATIONS',
  INTRASITE_NOTES_MANAGEMENT = 'INTRASITE_NOTES_MANAGEMENT',
  UPLOAD_INTRASITE_NOTES = 'UPLOAD_INTRASITE_NOTES',
  SCHOOL_CONFIGURATIONS = 'SCHOOL_CONFIGURATIONS',
  BUS_TRACKING_REPORT = 'BUS_TRACKING_REPORT',
  BUSES = 'BUSES',
  ROUTES = 'ROUTES',
  LIVE_TRIPS = 'LIVE_TRIPS',
  STUDENTS = 'STUDENTS'
}
